// Field settings.
export const ACCOUNT_NAME_MAX_LENGTH = 55;
export const NAME_FIELDS_MAX_LENGTH = 30;
